module.exports = __webpack_public_path__ + "static/media/logo＿green.c29516c2.svg";